import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import { Node_Type, TextStyle_TextAlignment } from './../../ricos-schema/legacy/wix/rich_content/v1';

/**
 * This decoration, through a data- attribute's styling,
 * sets list-style-position to 'inside' if the list item is centered.
 */
export const createListStylePositionDecorationPlugin = () => {
  return new Plugin({
    key: new PluginKey(`list-style-position`),
    props: {
      decorations: ({ doc }) => {
        const decorations: Decoration[] = [];
        doc.descendants((node, pos) => {
          if (node.type.name !== Node_Type.LIST_ITEM) {
            return;
          }

          if (node.attrs.textStyle.textAlignment === TextStyle_TextAlignment.CENTER) {
            decorations.push(
              Decoration.node(pos, pos + node.nodeSize, {
                'data-list-style-position': 'inside',
              })
            );
          }
        });
        return DecorationSet.create(doc, decorations);
      },
    },
  });
};
